<div class="overlay"
     [class.overlay-message]="isAfterSub"
     (click)="overlayClickHandler($event, overlay)"
     #overlay>
  <div class="modal-window font-size-b2b"
       #modal>
    <header class="modal-header padding-0">
      <h2 class="modal-title-b2b">Для туроператоров</h2>
    </header>
    <p class="margin-top-16">Система B2B-бронирования отелей для агентской сети</p>

    <header class="modal-header padding-0">
      <h2 class="modal-title-b2b">Для гостиничных сетей</h2>
    </header>
    <p class="margin-top-16">Платформа B2B-продаж и управления агентскими и корпоративными тарифами</p>

    <header class="modal-header padding-0">
      <h2 class="modal-title-b2b">Для принимающих компаний</h2>
    </header>
    <p class="margin-top-16">B2B-портал для работы с зарубежными партнерами</p>

    <header class="modal-header padding-0">
      <h2 class="modal-title-b2b">Функциональные возможности</h2>
    </header>

    <ul class="bron-system-functionality margin-top-16">
      <li>Работа с собственными контрактными тарифами у отелей</li>
      <li>Управление доступом в систему для агентов</li>
      <li>Корректировка цены для агентов</li>
      <li>Установление индивидуального размера комиссии для каждого агента</li>
      <li>Онлайн бронирование агентами</li>
      <li>Бронирование агентами с подтверждением</li>
      <li>Контроль взаиморасчетов с агентами</li>
      <li>Дополнительный интерфейс для агентов на английском языке</li>
    </ul>


    <div class="modal-buttons-demo">
      <button class="modal-btn cancel-btn"
              (click)="closeHandler()"
              #cancel>ОК
      </button>
    </div>
  </div>
</div>
